import React, { useState } from 'react';
import { Copy, Check, ExternalLink, AlertCircle } from 'lucide-react';
import { btnGhost, btnPrimary } from '../ui.jsx';

/** Step 7 — review, publish, share the link, or unpublish. */
export default function ReviewStep({ ctx }) {
  const { server, publish, busy } = ctx;
  const [copied, setCopied] = useState(false);
  const live = server?.page?.status === 'published';
  const problems = server?.problems || [];
  const url = server?.url || '';

  async function copy() {
    try { await navigator.clipboard.writeText(url); setCopied(true); setTimeout(() => setCopied(false), 1800); } catch { /* clipboard blocked */ }
  }

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold">Review and Save</h3>
        <p className="text-xs text-white/60">Take a moment to review your producer page on the right. Make sure your name, licenses and any figures are accurate — this page speaks for you.</p>
      </div>

      {problems.length > 0 && (
        <ul className="space-y-1 rounded-lg border border-amber-500/30 bg-amber-500/5 p-3 text-sm text-amber-200" data-testid="pp-problems">
          {problems.map((p) => <li key={p} className="flex items-start gap-2"><AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />{p}</li>)}
        </ul>
      )}

      {live ? (
        <div className="space-y-3 rounded-lg border border-emerald-500/30 bg-emerald-500/5 p-4" data-testid="pp-live">
          <div className="text-sm font-semibold text-emerald-300">Your producer page is live</div>
          <div className="flex items-center gap-2 rounded-lg bg-white/5 px-3 py-2 text-sm"><span className="min-w-0 flex-1 truncate">{url}</span></div>
          <div className="flex flex-wrap gap-2">
            <button type="button" className={btnGhost} onClick={copy}>{copied ? <><Check className="mr-1 inline h-3.5 w-3.5" />Copied</> : <><Copy className="mr-1 inline h-3.5 w-3.5" />Copy link</>}</button>
            <a className={btnGhost} href={url} target="_blank" rel="noopener noreferrer"><ExternalLink className="mr-1 inline h-3.5 w-3.5" />View page</a>
            <button type="button" className={btnGhost} disabled={busy} onClick={() => publish(false)}>Unpublish</button>
          </div>
        </div>
      ) : (
        <button type="button" className={btnPrimary} disabled={busy || problems.length > 0} onClick={() => publish(true)} data-testid="pp-publish">
          {busy ? 'Publishing…' : 'Create page'}
        </button>
      )}
    </div>
  );
}
